<p *ngIf="LABELS?.TITLE">
	<strong>{{ LABELS?.TITLE }}</strong>
</p>

<p class="u-text--sm u-text--xlight u-m-top--tiny">
	<ng-content></ng-content>
</p>

<div>
	<a *ngFor="let image of currentFiles" class="c-file__item u-m-top--sm" [href]="getUrl(image, 'original')" target="_blank" [style.background-image]="'url(' + getUrl(image) + ')'">
		<button *ngIf="!disabled" class="c-btn-circle c-btn-circle--red" (click)="removeFile(image, $event)">
			<tvcore-icon name="trash"></tvcore-icon>
		</button>
	</a>
</div>

<p *ngIf="error" class="u-text--sm u-text--error u-m-top--sm">{{ error }}</p>

<div *ngIf="!hideUpload && !disabled" class="c-file-selector u-m-top--sm" [class.c-file-selector--error]="showErrors && hasError()" [class.c-file-selector--dragging]="dragging">
	<div class="c-file-selector__button flex-row">
		<tvcore-icon name="paperclip"></tvcore-icon>
		<p class="u-m-left--xxs">{{ LABELS?.ADD_BUTTON }}</p>
	</div>

	<p class="u-text--sm u-text--light u-m-top--xxs">
		{{ LABELS?.TEXT }}
	</p>

	<input #uploadInput type="file" [accept]="acceptedFileTypes" (change)="fileSelect($event)" (dragenter)="dragging = true" (dragleave)="dragging = false" />
</div>

<p *ngIf="showErrors && hasError()" class="u-text--sm u-text--error u-m-top--sm">{{ LABELS?.ERROR_REQUIRED }}</p>
